export class RequestParameter {

  constructor(public name: string,
              public value: string | number | boolean | Blob) {
  }


}
